import { DeckCardInfoType } from 'types/search'

import DeckLink from 'components/misc/DeckLink'
import Icon from 'components/elements/Icon'
import Checkbox from 'components/formElements/Checkbox'
import DeckOptions from 'components/folderPage/DeckOptions'

import { useAppSelector } from 'redux/hooks'
import { useDeckDrag } from 'components/folderPage/folderHooks'

import { selectIsDeckMultiSelected, selectTotalMultiSelectedSize } from 'redux/folders/selectors'

import styles from './deckGridItem.module.scss'

type Props = {
  deck: DeckCardInfoType
  onToggleSelected: () => void
}

const DeckGridItem = ({ deck, onToggleSelected }: Props) => {
  const selected = useAppSelector(selectIsDeckMultiSelected(deck.id))
  const totalSelected = useAppSelector(selectTotalMultiSelectedSize)

  const [_collector, drag] = useDeckDrag(deck, selected, totalSelected)

  return (
    <div className={styles.container}>
      <DeckLink deck={deck} optionsOverride={<DeckOptions deck={deck} />} key={deck.id} />

      {selected && (
        <div className={styles.selected} onClick={onToggleSelected}>
          <Icon name="check" />
        </div>
      )}

      <div className={styles.extras}>
        {drag(
          <div className={styles.dragHandle}>
            <Icon name="bars" />
          </div>,
        )}

        <Checkbox checked={selected} onChange={onToggleSelected} />
      </div>
    </div>
  )
}

export default DeckGridItem
